export default {
  pdType: state => state.pdType,
  farLeftPd: state => state.far?.left?.pd,
  farRightPd: state => state.far?.right?.pd,
  closeLeftPd: state => state.close?.left?.pd,
  closeRightPd: state => state.close?.right?.pd,
  pdOptionsRange: (state) => Array.from({ length: 41 }, (_, i) => 40 + i),
  currentStep: state => state.currentStep,
  isAdvancing: state => state.isAdvancing,
  isGoingBack: state => state.isGoingBack,
  steps: state => {
    if (state.csv.length === 0) return []

    const customOrder = [
      'prescription_type',
      'prescription_table',
      'lens_type',
      'lens_quality',
      'thinning',
      'lens_pattern',
      'color'
    ]

    const csvKeys = Object.keys(state.csv[0]).filter(key =>
      !['id', 'price_1', 'price_2', 'price_3', 'price_4', 'hex_color', 'level']
        .includes(key)
    )

    return customOrder.concat(csvKeys.filter(k => !customOrder.includes(k)))
  },
  currentStepKey: (state, getters) => {
    if (state.currentStep <= 0 || state.currentStep - 1 > getters.steps.length) return null
    return getters.steps[state.currentStep - 1]
  },
  stepData: state => state.stepData,
  selections: state => state.selections,
  prescriptionData: state => state.prescriptionData,
  prescriptionDataSubmitted: state => state.prescriptionDataSubmitted,
  quantity: state => state.quantity,
  selectedSteps: (state, getters) => {
    const stepsWithSelections = getters.steps.filter(step => {
      return state.selections[step] !== undefined &&
             state.selections[step] !== null &&
             state.selections[step] !== 'Null';
    });

    if (state.selections['prescription_type'] !== undefined &&
        state.selections['prescription_type'] !== 'Χωρίς Συνταγή' &&
        getters.steps.includes('prescription_table') &&
        !stepsWithSelections.includes('prescription_table')) {

      const prescriptionTypeIndex = stepsWithSelections.indexOf('prescription_type');
      if (prescriptionTypeIndex !== -1) {
        stepsWithSelections.splice(prescriptionTypeIndex + 1, 0, 'prescription_table');
      }
    }

    return stepsWithSelections;
  },
  selectedStepsContainsNoPrescription: (state, getters) => {
    return state.selections['prescription_type'] !== 'Χωρίς Συνταγή';
  },
  csv: state => state.csv,
  productData: state => state.productData,
  getPrescriptionValuesSubcontent: () => (option) => {
    if (typeof option !== 'string') {
      return 'prescription-option-unknown'
    }
    const noAccents = option.toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

    const transliterate = (text) => {
      const greekToLatinMap = {
        'α': 'a', 'β': 'v', 'γ': 'g', 'δ': 'd', 'ε': 'e',
        'ζ': 'z', 'η': 'i', 'θ': 'th', 'ι': 'i', 'κ': 'k',
        'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': 'x', 'ο': 'o',
        'π': 'p', 'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'i',
        'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'o', 'σ': 's',
        'ς': 's'
      }

      return text.split('').map(char => greekToLatinMap[char] || char).join('')
    }

    const transformedOption = transliterate(noAccents)
    const sanitizedOption = transformedOption.replace(/[^a-z0-9\s]/g, '')
    return 'prescription-option-' + sanitizedOption.replace(/\s+/g, '-')
  },
  rowId: state => state.rowId,
  prices: state => state.prices,
  priceMapping: (state, getters) => {
    const mapping = {}
    const stepBasedPriceFields = {
      lens_quality: 'price_1',
      thinning: 'price_2',
      filter: 'price_3',
      lens_pattern: 'price_4'
    }
    getters.steps.forEach(step => {
      if (stepBasedPriceFields[step]) {
        mapping[step] = stepBasedPriceFields[step]
      }
    })
    return mapping
  },
  finalPrice: (state) => {
    if (!state.rowId || !state.csv || !state.csv.length || !state.productData) {
      console.warn('Missing required data for finalPrice calculation:', {
        hasRowId: !!state.rowId,
        hasCsv: !!state.csv,
        csvLength: state.csv?.length,
        hasProductData: !!state.productData
      });
      return 0
    }

    const selectedItem = state.csv.find(item => parseInt(item.id) === parseInt(state.rowId))

    if (!selectedItem) {
      console.warn('No matching item found for rowId:', state.rowId);
      return 0
    }

    let basePrice = parseFloat(state.productData.final_price || 0);
    const additionalPrice = [
      'price_1',
      'price_2',
      'price_3',
      'price_4'
    ].reduce((total, priceField) => {
      const price = parseFloat(selectedItem[priceField] || 0);
      return total + price;
    }, 0);

    const totalPrice = basePrice + additionalPrice;

    return parseFloat(totalPrice.toFixed(2))
  },
  pricingLevel: (state) => {
    if (!state.prescriptionData || Object.keys(state.prescriptionData).length === 0) {
      return 1
    }

    const { close, far } = state.prescriptionData

    const eyes = ['left', 'right']
    let maxCylValue = 0
    let maxSphValue = 0

    if (!close || !far) {
      return 1
    }

    eyes.forEach(eye => {
      const closeEyeData = close[eye]
      const farEyeData = far[eye]

      if (closeEyeData) {
        const cyl = parseFloat(closeEyeData.cyl) || 0
        const sph = parseFloat(closeEyeData.sph) || 0
        maxCylValue = Math.max(maxCylValue, Math.abs(cyl))
        maxSphValue = Math.max(maxSphValue, Math.abs(sph))
      }

      if (farEyeData) {
        const cyl = parseFloat(farEyeData.cyl) || 0
        const sph = parseFloat(farEyeData.sph) || 0
        maxCylValue = Math.max(maxCylValue, Math.abs(cyl))
        maxSphValue = Math.max(maxSphValue, Math.abs(sph))
      }
    })

    if (maxCylValue >= 4.25 || maxSphValue >= 10) {
      return 3
    }

    if (
      (maxCylValue >= 2.25 && maxCylValue < 4.25) ||
      (maxSphValue >= 6 && maxSphValue < 10)
    ) {
      return 2
    }

    return 1
  },
  isStepSelectable: (state, getters) => stepNumber => {
    if (stepNumber <= 0 || stepNumber > getters.steps.length) return false
    for (let i = 1; i < stepNumber; i++) {
      const stepKey = getters.steps[i - 1]
      if (!state.selections[stepKey]) {
        return false
      }
    }

    return true
  },
  buttonText () {
    return '<img src="/ui/main/img/cart-icon.svg" alt="cart" class="cart-icon" width="50px" height="50px">'
  },
  filteredRows: (state, getters) => {
    if (!state.csv || state.csv.length === 0) return []

    return state.csv.filter(row => {
      return getters.steps.every(step => {
        if (step === 'prescription_table') return true

        const selected = state.selections[step]
        if (selected === undefined || selected === null || selected === 'Null') return true
        return row[step] === selected
      })
    })
  },
  availableOptions: (state, getters) => {
    const filtered = getters.filteredRows
    if (!Array.isArray(filtered) || filtered.length === 0) {
      return []
    }
    const step = getters.currentStepKey
    let opts = [...new Set(filtered.map(r => r[step]))]
    const real = opts.filter(v => v && v !== 'Null')
    return real.length ? real : []
  }
}
